module.exports = __webpack_public_path__ + "images/155_1024.jpg";